import { JSEncrypt } from 'jsencrypt'

const CryptoJS = require('crypto-js')

class AuthUtils {
  constructor (encryptionKey) {
    this.encryptionKey = encryptionKey
  }

  static createParam (values) {
    // const param = {
    //   client_id: 'hytcebook',
    //   client_secret: 'hytcebook.7,f@e',
    //   username: values.email.trim(),
    //   password: values.password,
    //   time: new Date().valueOf()
    // }
    // const sign = md5.paramMd5(param, 'client_secret', 'hytcebook.7,f@e')
    // param.sign = sign
    // return param
  }

  generateRandomKey () {
    const random = CryptoJS.lib.WordArray.random(24)
    return CryptoJS.enc.Base64.stringify(random)
  }

  encryptKey (keyBase64) {
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(this.encryptionKey)
    return encrypt.encrypt(keyBase64)
  }

  aesEncryptEBC (word, keySec) {
    // aes加密
    const aeskey = CryptoJS.enc.Utf8.parse(keySec)
    const srcs = CryptoJS.enc.Utf8.parse(word)
    const encrypted = CryptoJS.AES.encrypt(srcs, aeskey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.ciphertext.toString()
  }

  aesDecryptEBC (word, keySec) {
    // aes解密
    const aeskey = CryptoJS.enc.Utf8.parse(keySec)
    const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
    const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    const decrypt = CryptoJS.AES.decrypt(srcs, aeskey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
  }

  // 兼容旧方法名
  aesEncrypt_EBC (word, keySec) {
    return this.aesEncryptEBC(word, keySec)
  }

  aesDecrypt_EBC (word, keySec) {
    return this.aesDecryptEBC(word, keySec)
  }

  async login (values, hide, setUserInfo, clearUserInfo) {
    // const param = AuthUtils.createParam(values)
    // const keyBase64 = AuthUtils.generateRandomKey()
    // const key = this.encryptKey(keyBase64)
    // const data = this.aesEncrypt_EBC(JSON.stringify(param), keyBase64)
    //
    // const encrypParam = {
    //   encryptionKey: key,
    //   encryptionData: data
    // }
  }
}

export default AuthUtils
